import React, { useState, useContext, useEffect, useRef } from 'react';
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from 'react-device-detect';
import themeContext from '../../context/theme/ThemeContext';
import { dropdownStyles } from '../../pages/StudyList/helpers/initData';
import {
  Checkbox,
  Dropdown,
  Icon,
  PrimaryButton,
  SearchBox,
  TextField,
} from '@fluentui/react';
import ClearIcon from '../SVGComponents/ClearIcon';
import { t } from 'i18next';
import {
  checkboxFilterStyle,
  searchFilterStyle,
} from '../../pages/StudyList/helpers/ConstantStyles';
import DropdownMoreIcon from '../SVGComponents/DropdownMoreIcon';
import { BORDER, TABS } from '../../constants/Constants';

const SortPopupFilterSectionV2 = (props) => {
  const [filterValue, setFilterValue] = useState('');
  const [filterClicked, setFilterClicked] = useState(false);
  const [applyButtonEnabled, setApplyButtonEnabled] = useState(false);
  const [showFilter, setShowFilters] = useState(false);
  const [showMoreFilter, setShowMoreFilter] = useState(false);

  const { themeName, getThemeColor } = useContext(themeContext);

  const displayListAppliedFilter = props.displayListAppliedFilter;
  const handleApplyClick = props.handleApplyClick;
  const handleClearFilter = props.handleClearFilter;
  const filterPopUpComponent = props.filterPopUpComponent;
  const removeBadgeFromFilter = props.removeBadgeFromFilter;
  const showSearch =
    props.showSearch != undefined && props.showSearch != null
      ? props.showSearch
      : true;
  const showSort =
    props.showSort != undefined && props.showSort != null
      ? props.showSort
      : true;
  const enhancedFilter =
    props.enhancedFilter != null && props.enhancedFilter != undefined
      ? props.enhancedFilter
      : false;

  function camelToUnderscore(key) {
    var result = key.replace(/([A-Z])/g, ' $1');
    return result.split(' ').join('_').toLowerCase();
  }

  const handleDropDownClick = (e, data) => {
    console.log(data);
    props.setSortObj(() => {
      const newItem = { ...props.sortObj };
      newItem.sortFieldText = data.text;
      newItem.sortFieldValue = data.key;
      newItem.sortDir = false;
      newItem.selected = true;
      return newItem;
    });
  };

  const handleSortIconClick = (e, data, sortDir) => {
    console.log('---Sort Icon Click Data ----', data, sortDir);
    props.setSortObj(() => {
      const newItem = { ...props.sortObj };
      newItem.sortFieldText = data.text;
      newItem.sortFieldValue = data.key;
      newItem.sortDir = sortDir;
      newItem.selected = true;
      return newItem;
    });
  };

  const onRenderOption = (option) => {
    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <span style={{ marginRight: '8px' }}>{option.text}</span>
        <div>
          <Icon
            onClick={(e) => {
              e.stopPropagation();
              handleSortIconClick(e, option, false);
            }}
            iconName={'SortDown'}
            aria-hidden="true"
          />
          <Icon
            onClick={(e) => {
              e.stopPropagation();
              handleSortIconClick(e, option, true);
            }}
            iconName={'SortUp'}
            aria-hidden="true"
          />
        </div>
      </div>
    );
  };

  const changeSortDir = () => {
    props.setSortObj(() => {
      const newItem = { ...props.sortObj };
      newItem.sortDir = !props.sortObj.sortDir;
      return newItem;
    });
  };

  const clearSort = () => {
    props.setSortObj(() => {
      const newItem = { ...props.sortObj };
      newItem.sortFieldText = '';
      newItem.sortFieldValue = '';
      newItem.sortDir = false;
      newItem.selected = false;
      return newItem;
    });
  };

  const searchInputStyle = {
    root: {
      width: isMobile ? '100%' : '160px',
    },
    field: {
      borderRadius: '7px',
    },
  };

  const searchIcon = {
    iconName: 'search',
    cursor: 'pointer',
    style: {
      color:
        themeName == 'dark' || themeName == 'dark-midnight'
          ? 'rgba(172, 172, 172, 0.75)'
          : '',
    },
  };

  const handleEnterKeyPress = (event) => {
    if (event.key === 'Enter') {
      setApplyButtonEnabled(false);
      handleApplyClick(filterValue);
    }
  };

  const handleRemoveFilters = () => {
    // setFilterClicked(false);
    // props.setFilterObj(() => {
    //   const newItem = { ...props.filterObj };
    //   newItem.filterInput = "";
    //   return newItem;
    // });
    setFilterValue('');
    if (!applyButtonEnabled) {
      setFilterClicked(false);

      props.setFilterObj(() => {
        const newItem = { ...props.filterObj };
        newItem.filterInput = null;
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }
  };

  const handleApplyFilterClick = (filterValue) => {
    setFilterClicked(true);
    setApplyButtonEnabled(false);
    handleApplyClick(filterValue);
  };

  const onHoverIn = () => {
    setShowMoreFilter(true);
  };
  const onHoverOut = () => {
    setShowMoreFilter(false);
  };

  useEffect(() => {
    if (!showFilter) {
      // props.setFirmList(props.storeFirmList);
    }
  }, [showFilter]);

  return (
    <div
      className="top-section-list-view-v3"
      style={{
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        background: themeName === "light"?TABS.LIGHT_GLOBAL_GRAY:"unset"
      }}
    >
      <div className="section-filter">
        {showSearch && (
          <>
            <p className="sort-search-text">Search By</p>

            <span className="patient-search-input-box">
              <TextField
                label=""
                placeholder={props.placeholder}
                styles={searchInputStyle}
                name="username"
                value={filterValue}
                //onBlur={props.onBlur}
                onChange={(e, data) => {
                  if (data == '') {
                    setApplyButtonEnabled(false);
                  } else {
                    setApplyButtonEnabled(true);
                  }
                  setFilterValue(data);
                  //props.setFilterObj({ filterInput: data });
                }}
                //iconProps={searchIcon}
                onKeyDown={handleEnterKeyPress}
              />
              <span
                className="cancel-patient-search"
                onClick={(event) => {
                  event.stopPropagation();
                  handleRemoveFilters();
                }}
              >
                {filterValue.length > 0 && <ClearIcon />}
              </span>
            </span>

            {/* )} */}

            <PrimaryButton
              iconProps={{
                iconName: 'Search',
                cursor: 'pointer',
              }}
              onClick={() => {
                if (filterValue != '') {
                  handleApplyFilterClick(filterValue);
                }
              }}
              text={''}
              className={
                !(filterValue != '' && applyButtonEnabled)
                  ? 'common-default-inactive-button study-list-filter-button search-active-button'
                  : 'common-default-active-button study-list-filter-button search-active-button'
              }
              styles={{
                root: {
                  width: '10px',
                  cursor: !(filterValue != '') ? 'not-allowed' : 'pointer',
                },
              }}
            />
          </>
        )}
        <div className="filter-sort-list-view">
          {showSort && (
            <>
              <p className="sort-by-text">Sort By</p>
              {!props.sortObj.selected ? (
                <Dropdown
                  options={props.sortDropdownOptions}
                  placeholder="Select"
                  onChange={(e, data) => handleDropDownClick(e, data)}
                  onRenderOption={onRenderOption}
                  styles={dropdownStyles}
                />
              ) : (
                <div className="study-list-badge-list-view">
                  <span className="badge-text-list-view">
                    {props.sortObj.sortFieldText}
                  </span>
                  <Icon
                    onClick={changeSortDir}
                    style={{
                      cursor: 'pointer',
                      // color: "white",
                      lineHeight: '2',
                      marginLeft: '5px',
                    }}
                    iconName={props.sortObj.sortDir ? 'SortUp' : 'SortDown'}
                    className="ms-fontSize-10"
                  ></Icon>
                  <Icon
                    onClick={clearSort}
                    style={{
                      cursor: 'pointer',
                      // color: "white",
                      lineHeight: '2',
                      marginLeft: '5px',
                    }}
                    iconName="Cancel"
                    className="ms-fontSize-10"
                  ></Icon>
                </div>
              )}
            </>
          )}
          {enhancedFilter && (
            <div
              className="list-view-filter-container"
              style={{ marginLeft: '10px' }}
            >
              <PrimaryButton
                iconProps={{
                  iconName: 'AddTo',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  //setShowFilters((prev) => !prev);
                  //setShowFilterOptions((prev) => !prev);
                  setShowFilters((prev) => !prev);
                }}
                text={t('button.filter')}
              />

              <FilterPopUpListView
                show={showFilter}
                onClickOutside={() => {
                  setShowFilters(false);
                  if (
                    props.handlePopupClose != null &&
                    props.handlePopupClose != null
                  ) {
                    props.handlePopupClose();
                  }
                }}
                handlePopupClose={props.handlePopupClose}
                handleApplyClick={handleApplyClick}
                setShowFilters={setShowFilters}
                handleClearFilter={handleClearFilter}
                filterPopUpComponent={filterPopUpComponent}
              />
            </div>
          )}
          {displayListAppliedFilter?.length > 0 &&
            displayListAppliedFilter.map(
              (item, ind) => {
                return (
                  ind <= 4 && (
                    <div
                      key={ind}
                      className="study-list-badge-list-view"
                      style={{ marginLeft: '10px', cursor: 'auto' }}
                      //onClick={() => setShowFilterOptions(true)}
                    >
                      <span className="study-list-badge-text-list-view">
                        {item.label}
                      </span>

                      <Icon
                        onClick={(event) => {
                          event.stopPropagation();
                          removeBadgeFromFilter(item);
                        }}
                        style={{
                          cursor: 'pointer',
                          // color: "white",
                          lineHeight: '2',
                          marginLeft: '5px',
                        }}
                        iconName="Cancel"
                        className="ms-fontSize-10"
                      ></Icon>
                    </div>
                  )
                );
              }

              // </ScrollMenu>
            )}

          {displayListAppliedFilter?.length > 5 &&
            displayListAppliedFilter.map(
              (item, ind) => {
                return (
                  ind == 5 && (
                    <div
                      key={ind}
                      className="study-list-badge-list-view more-filter-hover"
                      style={{ marginLeft: '10px', cursor: 'pointer' }}
                      onMouseEnter={onHoverIn}
                      onMouseLeave={onHoverOut}
                      //onClick={() => setShowFilterOptions(true)}
                    >
                      <span className="study-list-badge-text-list-view">
                        +{displayListAppliedFilter?.length - 4 - 1}&nbsp;
                        <DropdownMoreIcon />
                      </span>
                      {showMoreFilter && (
                        <div
                          style={{ border: getThemeColor('border') }}
                          className="more-popup-hover"
                          onMouseEnter={onHoverIn}
                          onMouseLeave={onHoverOut}
                        >
                          {displayListAppliedFilter?.map((item, ind) => {
                            return (
                              ind > 4 && (
                                <div
                                  key={ind}
                                  className="study-list-badge-list-view"
                                  style={{
                                    marginLeft: '10px',
                                    cursor: 'auto',
                                    marginBottom: '10px',
                                  }}
                                  //onClick={() => setShowFilterOptions(true)}
                                >
                                  <span className="study-list-badge-text-list-view">
                                    {item.label}
                                  </span>

                                  <Icon
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      removeBadgeFromFilter(item);
                                    }}
                                    style={{
                                      cursor: 'pointer',
                                      // color: "white",
                                      lineHeight: '2',
                                      marginLeft: '5px',
                                    }}
                                    iconName="Cancel"
                                    className="ms-fontSize-10"
                                  ></Icon>
                                </div>
                              )
                            );
                          })}
                        </div>
                      )}
                    </div>
                  )
                );
              }

              // </ScrollMenu>
            )}

          {displayListAppliedFilter?.length > 0 && (
            <div style={{ marginLeft: '10px' }}>
              <PrimaryButton
                text="Clear All"
                onClick={() => {
                  setFilterValue('');
                  handleClearFilter();
                }}
              />
            </div>
          )}
        </div>
      </div>
      <div style={{ display: 'flex' }}>
        {props.buttonsTopBar.map((ele, index) => {
          return <React.Fragment key={index}>{ele.button}</React.Fragment>;
        })}
      </div>
    </div>
  );
};

export default SortPopupFilterSectionV2;

const FilterPopUpListView = (props) => {
  const ref = useRef(null);
  const { onClickOutside } = props;

  const showFilterPopUpComponent =
    props.filterPopUpComponent != null &&
    props.filterPopUpComponent != undefined
      ? true
      : false;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [onClickOutside]);

  if (!props.show) return null;

  return (
    <div
      className="filter-popup-study-list list-view-filter-container"
      ref={ref}
    >
      {showFilterPopUpComponent && props.filterPopUpComponent}
      <div className="study-list-filter-popup-button-section">
        <PrimaryButton
          text={t('button.apply')}
          onClick={() => {
            props.handleApplyClick();
            props.setShowFilters(false);
            if (
              props.handlePopupClose != null &&
              props.handlePopupClose != null
            ) {
              props.handlePopupClose();
            }
          }}
          className={
            true
              ? 'common-default-active-button'
              : 'common-default-inactive-button'
          }
        />
        <PrimaryButton
          text={t('button.cancel')}
          onClick={() => {
            props.setShowFilters(false);
            props.handleClearFilter();
            if (
              props.handlePopupClose != null &&
              props.handlePopupClose != null
            ) {
              props.handlePopupClose();
            }
          }}
          className="study-list-clear-all-button"
        />
      </div>
    </div>
  );
};
